import {
	FormControl,
	FormLabel,
	Heading,
	Input,
	PhoneInput,
	Stack,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { PostLoginOnboardingStepsProps } from "./post-login-onboarding";
import { useEffect, useState } from "react";
import { isNullOrWhiteSpace } from "../../utils/string-helper";
import { useTranslation } from "react-i18next";
import { useUpdateUserQuery } from "../../hooks/use-update-user-query";
import { ContactsSchema } from "../../models/user";
import { useUserContext } from "../../hooks/use-user-context";
import { useLocalePhoneInput } from "../../hooks/use-locale-phone-input";

export const PostLoginOnboardningContacts = ({ setContinueButton }: PostLoginOnboardingStepsProps) => {
	const { user } = useUserContext();
	const { t } = useTranslation();
	const { saveUserAsync } = useUpdateUserQuery(ContactsSchema);

	const [name, setName] = useState<string>("");
	const [nameInvalid, setNameInvalid] = useState(false);
	const phone = useLocalePhoneInput({ isRequired: true });
	const [relation, setRelation] = useState<string>();
	const [relationInvalid, setRelationInvalid] = useState(false);

	useEffect(() => {
		setContinueButton({
			isDisabled: isNullOrWhiteSpace(name) || !phone.isValid || isNullOrWhiteSpace(relation),
			save: () =>
				saveUserAsync({
					contacts: [
						{
							subject: user?.subject,
							name,
							phone: phone.e164,
							relation,
							id: 0,
						},
					],
				}),
		});
	}, [name, phone.e164, phone.isValid, relation, saveUserAsync, setContinueButton, user?.subject]);

	return (
		<Stack gap={ThemeSpaceVariable.Large}>
			<Heading as="h1">{t("post_login_onboarding_contacts_title")}</Heading>
			<Stack gap={ThemeSpaceVariable.Medium}>
				<FormControl isInvalid={nameInvalid} isRequired>
					<FormLabel>{t("contact_name")}</FormLabel>
					<Input
						value={name}
						onChange={(e) => setName(e.target.value)}
						size={"lg"}
						onBlur={(e) => setNameInvalid(isNullOrWhiteSpace(e.target.value))}
					/>
				</FormControl>
				<FormControl {...phone.formControlProps}>
					<FormLabel>{t("contact_phone")}</FormLabel>
					<PhoneInput {...phone.inputProps} size={"lg"} />
				</FormControl>
				<FormControl isInvalid={relationInvalid} isRequired>
					<FormLabel>{t("contact_relation")}</FormLabel>
					<Input
						value={relation}
						onChange={(e) => setRelation(e.target.value)}
						size={"lg"}
						onBlur={(e) => setRelationInvalid(isNullOrWhiteSpace(e.target.value))}
					/>
				</FormControl>
			</Stack>
		</Stack>
	);
};
